var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuHover({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 64,
    viewBox: "0 0 275 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_290_1495",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 275,
    height: 64
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 275,
    height: 64,
    rx: 10,
    fill: "#D176FB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_290_1495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.943 23.6552C223.53 31.7227 232.258 40.8483 234.44 51.4287C236.622 62.0091 232.258 74.0443 224.258 80.1941C216.257 86.2778 204.554 86.5424 194.173 90.3116C183.792 94.0147 174.733 101.289 164.286 101.95C153.839 102.611 142.07 96.6598 135.987 87.0714C129.904 77.4168 129.507 64.059 134.135 54.0077C138.83 43.9563 148.55 37.2774 157.542 29.1438C166.601 21.0101 174.866 11.4878 184.321 10.1652C193.71 8.84268 204.289 15.6538 213.943 23.6552Z",
    fill: "#D176FB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHover);
export default __webpack_public_path__ + "static/media/menu-hover.c69784f3e49b61f7b9144cd081f3ccd9.svg";
export { ForwardRef as ReactComponent };